import { SECOND_MS } from './time.ts';

export const COOKIES = {
  DEVICE_UUID_COOKIE_NAME: 'b3R0ZXJfd2ViX2RldmljZV91dWlk',
  SIGNIN_EMAIL_COOKIE_NAME: 'signin_email',
  IS_CREATE_ACCOUNT_COOKIE_NAME: 'is_create_account',
};

// forward urls are used to forward requests to the API server. This is taken care by Ngnix.
export const FORWARD_API_PREFIX = '/forward/api/v1';
export const FORWARD_PREFIX = '/forward';

export const TABLET_WIDTH = 768; // px

export const OTTER_AUDIO_SAMPLE_RATE = 16000;

export const SIGNIN_HEADER_HEIGHT = 72; // px

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const ZAPIER_API_KEY_NAME = 'Zapier API Key';

export const DESKTOP_APP_APPLE_SILICON_DOWNLOAD_URL =
  'https://assets.otter.ai/desktop-app/mac/production/otter_arm64_latest.dmg';
export const DESKTOP_APP_INTEL_CHIP_DOWNLOAD_URL =
  'https://assets.otter.ai/desktop-app/mac/production/otter_x64_latest.dmg';
export const DESKTOP_APP_DOWNLOAD_INFO_URL =
  'https://otter.ai/integrations/desktop';

export const USER_AGENT_DATA_PLATFORMS = {
  MAC_OS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  UNKNOWN: 'Unknown',
} as const;

// Desktop deeplink constants
export const DESKTOP_DEEPLINK_DETECTION_DELAY = 2 * SECOND_MS; // 2s

export const MIN_SILENCE_PERMITTED_SECONDS = 2;

export const PLAYBACK_SPEEDS = [0.5, 0.7, 1, 1.25, 1.75, 2, 3];
export const FOLDER_URL = 'folder';

export const GROUP_URL = 'group';
